import { getFeatureFlagsHandler } from '../getFeatureFlags/mock'
import { getRelatedTrialHospitalsHandler } from '../getRelatedTrialHospitals/mock'
import { getTrialHospitalsHandler } from '../getTrialHospitals/mock'

export const trialHandlers = [
  getTrialHospitalsHandler(),
  getRelatedTrialHospitalsHandler(),
  getFeatureFlagsHandler(),
]
